import React from 'react'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {NavBar} from '@vio/atlas/NavBar'
import {Brand} from '@vio/core/src/brand/types'

import {NavBarBackButton} from './NavBarBackButton'
import {BrandLogoComponent, NavBarBrandLogo} from './NavBarBrandLogo'

interface Props {
  brand: Brand
  BrandLogoComponent: BrandLogoComponent
  /** Where the logo links to. A brand's logoRedirectUrl takes precedence; falls back to the app root. */
  logoUrl?: string
  /** Desktop only: end-slot actions such as the preferences and user widgets. */
  actions?: React.ReactNode
  /** Mobile only: renders a back button in the start slot. */
  onBackButtonClick?: () => void
}

/**
 * Atlas Shared `NavBarPostBooking`: the nav bar for the post-booking surfaces
 * (Confirmation, Booking Management, My Bookings).
 *
 * Desktop shows the logo with the actions at the end. Mobile centres the logo,
 * with an optional back button and no end content.
 */
export const PostBookingNavBar = ({
  brand,
  BrandLogoComponent,
  logoUrl,
  actions,
  onBackButtonClick
}: Props) => {
  const {isMobile} = useDeviceLayout()

  const logo = (
    <NavBarBrandLogo
      brand={brand}
      logoUrl={logoUrl}
      BrandLogoComponent={BrandLogoComponent}
    />
  )

  if (!isMobile) {
    return <NavBar withDivider startContent={logo} endContent={actions} />
  }

  return (
    <NavBar
      withDivider
      centerAligned
      startContent={
        onBackButtonClick && <NavBarBackButton onClick={onBackButtonClick} />
      }
      centerContent={logo}
    />
  )
}
